<template>
  <div class="sun SectionTitle">
    <div class="logo slow delay-500ms" v-inview:animate="'fadeIn'">
      <img src="@/assets/images/landing/woori/funda-logo-white.png" alt="로고1" @click="increaseCount" />
      <v-icon color="white" class="mx-3">mdi-close</v-icon>
      <img src="@/assets/images/landing/woori/gov-smes-full.png" alt="로고2"/>
    </div>
    <div class="subtitle slow delay-500ms" v-inview:animate="'fadeIn'">
      <p>2024년 우리동네 크라우드펀딩 모집</p>
    </div>
    <div class="desc slow delay-500ms" v-inview:animate="'fadeIn'">
      <p class="white--text">
        우리동네 크라우드펀딩 대출형<br />
        소상공인이 동네 주민(개인 투자자)에게 <br />
        사업자금을 빌리고 이자를 상환하는 크라우드펀딩
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  components: {
  },
  props: {},
  data: function () {
    return {
      count: 0
    }
  },
  computed: {
  },
  async created() {
  },
  destroyed() {},
  methods: {
    increaseCount() {
      this.count = this.count + 1
      if (this.count >= 10) {
        let token = prompt('토큰 로그인')
        window.tokenlogin(token)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .SectionTitle {
    width: 100%;
    background-image: linear-gradient(146deg, #15b1ff, #0ba0ff 99%);
    padding-top: 42px;
    display: flex !important;
    flex-direction: column;
    overflow: hidden;

    .logo {
      display: flex !important;
      align-items: center;
      justify-content: center;

      img {
        max-height: 50px;
        max-width: 30%;
      }
    }

    .subtitle {
      padding: 20px;
      p {
        background-color: #f8ffcb;
        padding: 6px;
        border-radius: 16px;
        width: 100%;
        text-align: center;
        font-weight: 900;
        font-size: 18px;
      }
    }
    .desc {
      padding: 0 20px 20px 20px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      line-height: 1.5;
      margin: auto;

      p {
        margin: auto;
      }
    }

    .v-icon {
      color: white;
    }
  }
</style>
